// PedagogyType — how a course is taught + tested.
//
// Decision (Session 19D): multi-select (1–4 items). Real courses are often
// hybrid (e.g. 商科 case_study + essay_writing; CS 系算法课 quantitative + coding).
// Cap at 4 to avoid noise — if a course is "everything", that's signal of
// taxonomy mismatch rather than pedagogy reality.
//
// 'custom' opens a free-text customPedagogy field — escape hatch for niche
// formats (e.g. studio critique, oral defense, bedside teaching). The custom
// label feeds into the AI prompt as additional pedagogy context.
import { z } from 'zod';
export const PedagogyTypeSchema = z.enum([
    'case_study', // 案例研讨
    'conceptual', // 概念框架（理论 / 模型为主）
    'quantitative', // 推导计算（数学推导 / 量化分析）
    'lab_practice', // 实验 / 实操
    'memorization', // 记忆密集（词汇 / 术语 / 名词解释）
    'essay_writing', // 论文写作（人文 / 法学 / 政策分析）
    'coding', // 编程实现（CS / 数据科学）
    'custom', // 自定义 — 配 customPedagogy 文本
]);
export const ALL_PEDAGOGY_TYPES = PedagogyTypeSchema.options;
//# sourceMappingURL=pedagogy-type.js.map